import { useEffect, useState } from 'react';
import { useGetReleaseNotes } from './useGetReleaseNotes';
import { ReleaseNote } from '../interface/releaseNotes';
import { useLanguage } from '../context/LanguageContext';
import {
  RELEASE_NOTES_API_INTERVAL,
  RELEASE_NOTES_PRODUCT_IDENTIFIER,
} from '../constants/constants';

export const useReleaseNotesPolling = (fromProfile: boolean = false) => {
  const { language } = useLanguage();
  const [latestReleaseNote, setLatestReleaseNote] = useState<ReleaseNote | null>(null);
  const { data, refetch, isLoading, isFetching } = useGetReleaseNotes({
    productIdentifier: RELEASE_NOTES_PRODUCT_IDENTIFIER,
    language,
    latestOnly: true,
    limit: 1,
  });

  useEffect(() => {
    if (fromProfile) return;
    const interval = setInterval(() => {
      refetch();
    }, RELEASE_NOTES_API_INTERVAL);
    return () => clearInterval(interval);
  }, [refetch, fromProfile]);

  useEffect(() => {
    if (data && data.length > 0) {
      setLatestReleaseNote(data[0]);
    }
  }, [data]);

  return { latestReleaseNote, isLoading: isLoading || isFetching };
};
